import { createContext } from 'react';
import type { RealtimeContextValue } from '../types/realtime-context.type';

/** Authenticated application socket state; consumers require its provider. */
export const RealtimeContext = createContext<RealtimeContextValue | null>(null);
